



































































import { Vue, Component } from 'vue-property-decorator'
import { EventBus } from '@/Infrastructure/EventBus/EventBus'
import { ExpedienteDto } from '@/Application/Expediente'
import { ReferenciaExpediente } from '@/Domain/Expediente'
import ExpedienteDetails from '@/UI/UserProcedures/WonProcedures/WonProcedureDetailTabs/ExpedienteDetails.vue'
import Accounting from '@/UI/UserProcedures/WonProcedures/WonProcedureDetailTabs/Accounting.vue'
import Award from '@/UI/UserProcedures/WonProcedures/WonProcedureDetailTabs/Award.vue'
import Execution from '@/UI/UserProcedures/WonProcedures/WonProcedureDetailTabs/Execution.vue'
import Recognition from '@/UI/UserProcedures/WonProcedures/WonProcedureDetailTabs/Recognition.vue'
import { FetchDetailsExpedienteCommandHandlerProvider } from '@/Infrastructure/Expediente/FetchDetailsExpedienteCommandHandlerProvider'
import { FetchDetailsExpedienteCommand } from '@/Application/Expediente/FetchDetailsExpedienteCommand'

@Component({
  components: {
    ExpedienteDetails,
    Accounting,
    Award,
    Execution,
    Recognition
  }
})
export default class WonProcedureDetail extends Vue {
  tab = 'award'
  expediente: ExpedienteDto | null = null

  public mounted (): void {
    this.loadData()
  }

  public clickTab (tab: string): void {
    this.tab = tab
  }

  public loadData (): Promise<void> {
    EventBus.$emit('loading', true)
    const referenciaExpediente = new ReferenciaExpediente(this.$route.params.numExpediente)
    return this.loadDetails(referenciaExpediente)
      .then((response: ExpedienteDto) => {
        this.expediente = response
      })
      .finally(() => {
        EventBus.$emit('loading', false)
      })
  }

  public loadDetails (numExpediente: ReferenciaExpediente): Promise<ExpedienteDto> {
    const provider = new FetchDetailsExpedienteCommandHandlerProvider()
    const command = new FetchDetailsExpedienteCommand(numExpediente)
    const handler = provider.provide()
    return handler.handle(command)
  }
}
